import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import { activeAgents, agentsListing, getCities } from "../utils/routes";
// import img from "../assets/img/Background.png";
import { Rings } from "react-loader-spinner";
import ReactSelect from "react-select";
import Pagination from "../components/pagination/Pagination";
import user from "../assets/img/user icon.svg";
import { FiDownload } from "react-icons/fi";
import IllLocater from "../assets/img/ill-locater.svg";
// import IconContactCard from "../assets/img/icon-contact-card.png";
import IconContactCard from "../assets/img/icon-contact-card.svg";
import IconUser from "../assets/img/icon-user.svg";
import IconLocation from "../assets/img/icon-location.svg";

function Agents() {
  let PageSize = 5;

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const [agentName, setAgentName] = useState("");
  const [agentType, setAgentType] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [city, setCity] = useState([]);
  const [data, setData] = useState();

  const cityOptions = cityList?.map((item) => {
    return {
      label: item.refValue,
      value: item.refId,
      repTypeId: item.repTypeId,
    };
  });

  const options = [
    { value: "BIOMETRIC", label: "BIOMETRIC" },
    { value: "NONBIOMETRIC", label: "NONBIOMETRIC" },
  ];

  const getAllCities = () => {
    const getUserRequestDTO = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      fetch(getCities, getUserRequestDTO)
        .then((res) => res.json())
        .then((result) => {
          setLoading(false);
          setCityList(result.result);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const agentFilteration = (payload) => {
    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };
    try {
      fetch(activeAgents, getUserRequestDTO)
        .then((res) => res.json())
        .then((result) => {
          setLoading(false);
          setData(result?.result);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const payload = {
      name: agentName,
      verificationStatusId: agentType.value ? agentType.value : "",
      city: city.value ? city.value : "",
      pageNumber: currentPage,
      pageSize: PageSize,
    };
    getAllCities();
    agentFilteration(payload);
  }, [currentPage]);

  const onReset = () => {
    setAgentName("");
    setAgentType([]);
    setCity([]);
    const payload = {
      name: "",
      verificationStatusId: "",
      city: "",
      pageNumber: 1,
      pageSize: 5,
    };
    agentFilteration(payload);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    const payload = {
      name: agentName,
      verificationStatusId: agentType.value ? agentType.value : "",
      city: city.value ? city.value.toString() : "",
      pageNumber: currentPage,
      pageSize: PageSize,
    };
    agentFilteration(payload);
  };

  // const paginatedData = useMemo(() => {
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   return data?.elements?.slice(firstPageIndex, lastPageIndex);
  // }, [currentPage, data]);

  // console.log(paginatedData, "paginatedData");

  return (
    <div>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <section className="faq__section-one ">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6">
              <div className="faq__mainheading">
                <h1>
                  Locate OneZapp{" "}
                  <span className="d-block" style={{ color: "#91298C" }}>
                    Agents
                  </span>
                </h1>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 order-first order-md-last">
              <center>
                <div>
                  <img className="img-fluid-hero" src={IllLocater}></img>
                </div>
              </center>
            </div>
          </div>
        </div>
      </section>

      <section className="agent-listing">
        <div className="container">
          <div className="card filter-agents">
            <form className=" form-wrapper">
              <div className="row align-items-center m-0">
                <div className="col-lg-3">
                  <div className="form-group mb-0">
                    <div className="form-icon">
                      <img src={IconContactCard} width={20} />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Agent Name"
                      value={agentName}
                      onChange={(e) => setAgentName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group mb-0">
                    <div className="react-select">
                      <div className="form-icon">
                        <img src={IconUser} width={18} />
                      </div>
                      <ReactSelect
                        value={agentType}
                        options={options}
                        className="react-select"
                        classNamePrefix="react-select"
                        placeholder="Agent Type"
                        isSearchable={false}
                        onChange={(option) => {
                          setAgentType(option);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group mb-0">
                    <div className="react-select">
                      <div className="form-icon">
                        <img src={IconLocation} />
                      </div>
                      <ReactSelect
                        options={cityOptions}
                        value={city}
                        className="react-select"
                        classNamePrefix="react-select"
                        placeholder="City"
                        isSearchable={true}
                        onChange={(option) => {
                          setCity(option);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 d-flex justify-content-between">
                  <button
                    type="submit"
                    className="btn border"
                    style={{
                      background: "#481047 !important",
                      color: "white",
                      borderRadius: 100,
                    }}
                    onClick={onSubmit}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-text text-pri fw-bold"
                    onClick={onReset}
                  >
                    Reset All
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="table-wrapper card p-0">
            {data?.elements && data?.elements.length ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Agent Type</th>
                    <th>City</th>
                    <th>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.elements?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.fullName}</td>
                        <td>{item.verificationStatusName}</td>
                        <td>{item.city}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <table>
                <tbody>
                  <tr>
                    <td height className="text-center border-0 text-pri py-5">
                      No Record Found
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={[data?.total]}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Agents;
